import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PartnersComponent } from '@app/shared/components/partners/partners.component';
import { NewsletterComponent } from '@app/shared/components/newsletter/newsletter.component';
import { forkJoin, of, catchError } from 'rxjs';
import { GestaoPaginaService } from '@app/shared/components/api/services/gestao-pagina.service';
import { DominioService } from '@app/shared/components/api/services/dominio.service';
import { CampanhaService } from '@app/shared/components/api/services/campanha.service';
import { MoneyPipe } from '@app/shared/pipes/money.pipe';

import { RouterLink } from '@angular/router';
import { DashboardService } from '@app/shared/components/api/services/dashboard.service';

@Component({
  selector: 'app-sobre-nos',
  imports: [
    CommonModule,
    RouterLink,
    PartnersComponent,
    NewsletterComponent,
    MoneyPipe,
  ],
  providers: [
    GestaoPaginaService,
    DominioService,
    DashboardService,
    CampanhaService,
  ],
  templateUrl: './sobre-nos.component.html',
  styleUrl: './sobre-nos.component.scss',
})
export class SobreNosComponent implements OnInit {
  private readonly gestaoPaginaService = inject(GestaoPaginaService);
  private readonly dominioService = inject(DominioService);
  private readonly dashboardService = inject(DashboardService);
  private readonly campanhaService = inject(CampanhaService);
  missao: string = '';
  visao: string = '';
  valores: string = '';
  sobre: string = '';
  InformacoeSobre: any;
  stats: any = {
    totalCampanhas: 0,
    totalUtilizadores: 0,
    totalApoios: 0,
  };

  ngOnInit(): void {
    this.loadContents();
    this.getInformations();
  }

  getInformations() {
    this.dominioService.list().subscribe({
      next: (res: any) => {
        this.InformacoeSobre = res.data;
      },
    });

    this.dashboardService
      .getEstatisticasPublicas()
      .pipe(catchError(() => of(null)))
      .subscribe({
        next: (stats: any) => {
          if (stats) {
            this.stats = {
              totalCampanhas: stats.totalCampanhas ?? 0,
              totalUtilizadores: stats.totalUtilizadoresAtivos ?? 0,
              totalApoios: stats.totalFinanciado ?? stats.pagamentosConfirmados ?? 0,
            };
          }
        },
        error: (err) => {
          console.error('Erro ao carregar estatísticas em Sobre Nós:', err);
        },
      });
  }

  // dropdowns
  loadContents() {
    forkJoin({
      // Valores
      missao: this.gestaoPaginaService.getMissao(),
      visao: this.gestaoPaginaService.getVisao(),
      valores: this.gestaoPaginaService.getValores(),
      sobre: this.gestaoPaginaService.getSobre(),
    }).subscribe((response) => {
      this.missao = response.missao ?? '';
      this.visao = response.visao ?? '';
      this.valores = response.valores ?? '';
      this.sobre = response.sobre ?? '';
    });
  }

  scrollTo(elementId: string): void {
    const el = document.getElementById(elementId);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
}
